import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import './index.css';
import App from './App.tsx';
import { bootstrapLocalization } from './localization/bootstrap';
import { LocalizationProvider } from './localization/providers/LocalizationProvider';
import { BootstrapPageLoader } from './components/PageLoader';

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <BootstrapPageLoader />
  </StrictMode>,
);

bootstrapLocalization()
  .then(({ i18n, localization }) => {
    root.render(
      <StrictMode>
        <I18nextProvider i18n={i18n}>
          <LocalizationProvider service={localization}>
            <App />
          </LocalizationProvider>
        </I18nextProvider>
      </StrictMode>,
    );
  })
  .catch((error) => {
    console.error('Localization bootstrap failed', error);
    root.render(
      <StrictMode>
        <div className="min-h-screen flex items-center justify-center p-8 text-center text-red-600">
          Localization yüklenemedi.
        </div>
      </StrictMode>,
    );
  });
